// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5306":"012f3b8d","6334":"5166a57d","7242":"736c40c5"}[chunkId] + ".css";
};